import { PaymentMethod } from 'ha/services/apiV2/types/PaymentMethod';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<PaymentMethod[]>('GET', `/api/v2/user/${userId}/payment-methods`);
